import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './types';
import { IResponseCyclesCode } from 'v2/resources/types/cycles';

const cyclesCodeSlice = createSlice({
  name: 'cyclesCode',
  initialState,
  reducers: {
    setCyclesCode: (state, action: PayloadAction<IResponseCyclesCode[]>) => {
      return {
        ...state,
        cyclesCode: action.payload,
      };
    },
  },
});

export const { setCyclesCode } = cyclesCodeSlice.actions;
export default cyclesCodeSlice.reducer;
